import React from 'react';

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";

import PeopleIcon from "@mui/icons-material/People";
import PetsIcon from "@mui/icons-material/Pets";

import {
    BookingAccommodationUnits,
    TextIconListElement
} from "./BookingComponents";
import StackedDateRange from "../../components/Date/StackedDateRange";
import {useNavigate} from "react-router-dom";


const BookingCard = props => {
    const {booking, accommodations} = props;
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        navigate(`/main/bookings/${booking.id}`);
    }

    return (
        <Card sx={{mb: 2}}>
            <CardActionArea component="div" onClick={handleClick}>
                <CardContent>
                    <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mb: 1}}>
                        <Box sx={{fontWeight: "medium"}}>{booking.getFullName("Prenotazione senza nome")}</Box>
                        <Box sx={{color: 'text.primary'}}>#{booking.codeNumber}</Box>
                    </Box>
                    <Grid container spacing={1} sx={{pb: {xs: 0, md: 1}}}>
                        <Grid item xs={12} md={6}>
                            <Box sx={{display: 'flex'}}>
                                <StackedDateRange arrivalDate={booking.getArrival()}
                                                  departureDate={booking.getDeparture()}
                                                  small
                                                  sx={{width: 130}}/>
                                <BookingAccommodationUnits accommodations={accommodations} booking={booking} small/>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}
                              sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                  alignItems: 'center'
                              }}>
                            <TextIconListElement iconComponent={PeopleIcon}
                                                 text={booking.getPeopleLabel()}/>

                            {
                                booking.petsNumber > 0 &&
                                <PetsIcon fontSize="small"/>
                            }
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default BookingCard;